import { act } from 'react-test-renderer';
import {
    getLandingPageComponentList,
    createLandingPageComponent,
    updateLandingPageComponent,
    deleteLandingPageComponent,
    getLandingPageData,
    getLandingPageExportStatus,
    exportLandingPage
  } from '../services/api';
  
  // const mockData = {
  //   "templateType": 1,
  //   "wechatMiniProgramUrl": "8gitw",
  //   "buttonColor": "#ff0000",
  //   "landingPage": "i3dil",
  //   "callLink": "24ufq",
  //   "updateTime": "2023-10-16 21:27:19",
  //   "title": "22oug",
  //   "button": "kubgq",
  //   "uid": 97,
  //   "forwardType": 1,
  //   "createTime": "2026-06-30 23:37:36",
  //   "picList": [
  //     "ypzt4",
  //   ],
  //   "wechatMiniProgramId": "u17es",
  //   "name": "epx1w",
  //   "sponsorUid": 12,
  //   "landingPageUrl": "k0p1s",
  //   "status": 91,
  // };
  
  export default {
    namespace: 'market',
  
    state: {
      pageListData: {
        total: 1,
        list: [],
      },
      componentListData: {
        total: 1,
        list: [],
      },
      loading: false,
    },
  
    effects: {
      *getLandingPageData({ payload }, { call, put }) {
        const response = yield call(getLandingPageData, payload);
        yield put({ type: 'setPageData', payload: response });
      },
      *getLandingPageExportStatus({ payload }, { call }) {
        const response = yield call(getLandingPageExportStatus, payload);
        return response;
      },
      *exportLandingPage({ payload }, { call }) {
        const response = yield call(exportLandingPage, payload);
        return response;
      },
      *getPageList({ payload }, { call, put }) {
        yield put({
          type: 'changeLoading',
          payload: true,
        });
        const response = yield call(getLandingPageComponentList, payload);
        yield put({
          type: 'loadPageListData',
          payload: response,
        });
        yield put({
          type: 'changeLoading',
          payload: false,
        });
      },
      *createPage({ payload, callback }, { call, put }) {
        const response = yield call(createLandingPageComponent, payload);
        if (callback) {
          callback(response);
        }
      },
      *updatePage({ payload, callback }, { call, put }) {
        const response = yield call(updateLandingPageComponent, payload);
        if (callback) {
          callback(response);
        }
      },
      *deletePage({ payload, callback }, { call, put }) {
        const response = yield call(deleteLandingPageComponent, payload);
        if (callback) {
          callback(response);
        }
      },
    },
  
    reducers: {
      setPageData(state, action) {
        if(!action.payload) return;
        return {
          ...state,
          componentListData: action.payload
        }
      },
      loadPageListData(state, action) {
        return {
          ...state,
          pageListData: action.payload,
        };
      },
      changeLoading(state, action) {
        return {
          ...state,
          loading: action.payload,
        };
      },
    },
  };
  